import React from "react";
export const ElementObserverContext = React.createContext({
    activeBreakpoints: [],
    currentBreakpoint: null,
    observedElementBottom: null,
    observedElementHeight: null,
    observedElementLeft: null,
    observedElementRect: {},
    observedElementRight: null,
    observedElementTop: null,
    observedElementWidth: null,
    observedElementX: null,
    observedElementY: null
});
export const ElementObserverConsumer = ElementObserverContext.Consumer;
